function initFaqAccordion() {
  const faqSection = document.getElementById("faq-section");
  if (!faqSection || faqSection.dataset.faqBound === "true") return;

  faqSection.dataset.faqBound = "true";

  faqSection.addEventListener("click", (event) => {
    const question = event.target.closest(".faq-question");
    if (!question || !faqSection.contains(question)) return;

    event.preventDefault();

    const item = question.closest(".faq-item");
    const toggle = question.querySelector(".faq-toggle");
    if (!item) return;

    const isActive = item.classList.contains("active");

    faqSection.querySelectorAll(".faq-item.active").forEach((openItem) => {
      if (openItem === item) return;
      openItem.classList.remove("active");
      const openToggle = openItem.querySelector(".faq-toggle");
      if (openToggle) openToggle.textContent = "+";
    });

    if (isActive) {
      item.classList.remove("active");
      if (toggle) toggle.textContent = "+";
    } else {
      item.classList.add("active");
      if (toggle) toggle.textContent = "×";
    }
  });
}

document.addEventListener("DOMContentLoaded", initFaqAccordion);
document.addEventListener("turbolinks:load", initFaqAccordion);
